module.exports = __webpack_public_path__ + "static/img/04.2af2c69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/04.jpg
// module id = uZDX
// module chunks = 1